import React, {Fragment} from 'react'; /* eslint-disable-line */
import ReactDOM from "react-dom";
import {Provider} from 'react-redux';

export class RenderService {
    constructor(store) {
        this._store = store;
    }

    render(component, element) {
        const currentEl = window.document.querySelector(element);

        if (!currentEl || !component) {
            return;
        }

        ReactDOM.render(
            <Provider store={this._store}>
                {component}
            </Provider>,
            currentEl
        );
    }
}
